module.exports = __webpack_public_path__ + "static/assets/75f5f189fdc419824a8134db6eb63881.woff2";